import { MouseEvent } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import openCSVUpload from '../../actions/modals/openCSVUpload'

import NewBookingCSVUpload from '../../components/NewBookingCSVUpload'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

export interface NewBookingCSVUploadProps {
  isDisabled: boolean
}

export const mapStateToProps = (
  _state: ReduxStoreInterface,
  { isDisabled }: NewBookingCSVUploadProps
) => ({
  isDisabled,
})

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  openCSVUpload: (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()

    dispatch(openCSVUpload())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBookingCSVUpload)
